import { type FC, useState } from "react";

import {
  ConfirmationDialog,
  Paragraph,
  WizardDrawer as HightouchUIWizardDrawer,
  type WizardDrawerProps,
  Portal,
} from "@hightouch/htui";

type Props = Readonly<WizardDrawerProps> & {
  isDirty?: boolean;
};

export const WizardDrawer: FC<Props> = ({
  isOpen = false,
  size = "md",
  isDirty = false,
  onClose,
  ...props
}) => {
  const [isExiting, setIsExiting] = useState(false);

  function handleExit() {
    if (isDirty) {
      setIsExiting(true);
    } else {
      onClose();
    }
  }

  return (
    // Both the wizard drawer and the confirmation dialog render within their own portals, which can cause stacking issues under the hood
    // This portal is necessary to ensure the stacking is correct and the confirmation dialog is on top of the wizard drawer.
    <Portal>
      <HightouchUIWizardDrawer
        isOpen={isOpen}
        size={size}
        onClose={handleExit}
        {...props}
      />
      <ConfirmationDialog
        isOpen={isExiting}
        title="Are you sure?"
        confirmButtonText="Discard changes"
        variant="warning"
        onClose={() => setIsExiting(false)}
        onConfirm={() => {
          setIsExiting(false);
          onClose();
        }}
      >
        <Paragraph>You will lose any unsaved changes.</Paragraph>
      </ConfirmationDialog>
    </Portal>
  );
};
